<template>
  <div class="stats-filter-view">

    <h3 v-if="$globals.isMobile"><a href="#" :class="{active: isActive}" @click="toggleList"><img src="../assets/triangle.svg"/>Themen auswählen</a></h3>

    <transition name="slide" mode="out-in">
    <div class="stats-filter" v-show="isActive || !$globals.isMobile">
      <div class="filter-element">

        <RadioButton
          v-bind:id="filters[0].label"
          v-bind:isDisabled="!filterActive"
          v-bind:filter="filters[0]"
          v-bind:checked="filterActive"
          name="grp-type"
          @setFilter="updateFilter">
        </RadioButton>

      </div>
      <div class="filter-list">

        <div class="filter-element"
          v-for="(filter, index) in this.filters"
          v-if="index != 0">
          <RadioButton
            v-bind:id="filter.label"
            v-bind:isDisabled="!filterActive"
            v-bind:filter="filter"
            name="grp-type"
            @setFilter="updateFilter">
          </RadioButton>
        </div>

      </div>
    </div>
    </transition>

  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue';

export default {
  name: 'statsfilter',
  components: {
    RadioButton,
  },
  data() {
    return {
      isActive: false,
      isMobile: false,
    };
  },
  computed: {
    orderedFilter() {
      let filterEven = [];
      const filters = JSON.parse(JSON.stringify(this.filters));
      filters.shift();
      for (let i = 0; i < filters.length; i += 1) {
        if (i % 2 === 0) {
          const filter = filters.splice(i, 1);
          filterEven = filterEven.concat(filter);
        }
      }
      return filterEven.concat(filters);
    },
  },
  props: {
    filterActive: false,
    filters: false,
  },
  methods: {
    toggleList() {
      this.isActive = !this.isActive;
    },
    updateFilter(filter) {
      this.$emit('updateFilter', filter);
    },
  },
};
</script>

<style scoped lang="scss">

.stats-filter-view {
  border-top: 1px solid $color-grey-dark;
  border-bottom: 1px solid $color-grey-dark;
  margin: 0 0 20px;
  clear: both;

  @include bp(s) {
    border: none;
  }
}

h3 {
  position: relative;
  text-align: left;
  font-size: 12px;
  margin: 0;
  margin: 8px 20px;

  a {
    display: block;
    padding-left: $padding-default;
    color: $color-brand;

    img {
      position: absolute;
      top: 50%;
      left: 0;
      width: 15px;
      height: 15px;
      @extend .animateAll;
      transform: translateY(-50%) rotate(90deg);
    }

    &.active img {
      transform: translateY(-50%) rotate(180deg);
    }

  }
}

.stats-filter {
  clear: both;
  margin-top: 10px;
  overflow: hidden;
  margin: $padding-default/2 $padding-default;

  @include bp(s) {
    margin: 0;
    overflow: initial;
  }

  .filter-list {
    clear: both;
  }
  .filter-element {
    text-align: left;
    width: 50%;
    height: 50px;
    float: left;
    display: grid;
    justify-content: start;
    align-content: center;

    &:nth-child(even) {
      .radiobutton {
        margin-left: 20px;
      }
    }
  }
}
</style>
